App.prototype.buildRadios = function (data, targetElement) {
    data.forEach(function (item) {
        targetElement.append('<h3>'+item.name+'</h3>')
    });
};
